import { db } from '../services/firebase';
import { getDoc, doc, setDoc, updateDoc } from 'firebase/firestore';

// Conjunto para almacenar en memoria los IDs de administradores detectados en la sesión actual
const adminIdsCache = new Set(['JlSANylhk7YUCSX5wj9sfuYRf6B3']); // Tu ID como valor inicial

/**
 * Registra dinámicamente a un usuario como administrador cuando inicia sesión
 * Esta función se debe llamar en el componente de AuthContext
 */
export const registerAdminUser = async (userId, userData) => {
  if (!userId) return false;
  
  try {
    // Verificar si el usuario tiene rol de administrador
    const isAdmin = 
      userData?.role === 'admin' || 
      userData?.isAdmin === true || 
      (userData?.permissions && userData?.permissions.admin === true);
    
    if (isAdmin) {
      console.log(`✅ Usuario ${userId} detectado como administrador`);
      adminIdsCache.add(userId);
      
      // Opcionalmente, actualizar su documento para asegurar que tiene los campos necesarios
      try {
        const userRef = doc(db, 'users', userId);
        await updateDoc(userRef, {
          role: 'admin',
          isAdmin: true,
          updatedAt: new Date(),
          _adminRegistered: true
        });
        console.log(`✅ Información de administrador actualizada en la base de datos para ${userId}`);
      } catch (updateError) {
        console.error(`⚠️ No se pudo actualizar la info de administrador: ${updateError.message}`);
        // Continuamos aunque falle la actualización
      }
      
      return true;
    }
    return false;
  } catch (error) {
    console.error(`❌ Error verificando si ${userId} es administrador:`, error);
    return false;
  }
};

/**
 * Obtiene todos los IDs de administradores registrados en esta sesión
 * @returns {string[]} - Array con los IDs de administradores
 */
export const getAllAdminIds = () => {
  return Array.from(adminIdsCache);
};

/**
 * Verifica si un usuario es administrador según el caché local
 */
export const isAdminUser = (userId) => {
  if (!userId) return false;
  return adminIdsCache.has(userId);
};

/**
 * Fuerza el registro de un ID como administrador (útil para casos de emergencia)
 */
export const forceRegisterAdmin = (userId) => {
  if (userId) {
    adminIdsCache.add(userId);
    console.log(`🔑 ID ${userId} registrado manualmente como administrador`);
    return true;
  }
  return false;
};
